module.exports = __webpack_public_path__ + "img/faq.a00e8ed3.png";